import React, { useState, useEffect, useRef } from 'react';


const FilterBar = ({ isDarkMode }) => {
  const [filters, setFilters] = useState({
    module: '',
    function: '',
    pricing: ''
  });

  const filterOptions = {
    module: ['Building', 'Planning', 'Permits', 'Inspections'],
    function: ['Communication', 'Workflow', 'Validation', 'Event'],
    pricing: ['Subscription', 'Per Use', 'Flat Rate']
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
    console.log(`Filter ${filterType} changed to: ${value}`);
  };

  return (
    <div className={`rounded-lg p-4 mb-5 flex items-center flex-wrap border transition-colors duration-300 ${
      isDarkMode 
        ? 'bg-[#1F2023] border-gray-600' 
        : 'bg-white border-gray-200'
    }`}>
      <div className={`text-lg font-medium mr-5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
        Filter by:
      </div>
      
      {Object.entries(filterOptions).map(([key, options]) => (
        <div key={key} className="relative mr-2.5 mb-1">
          <select
            value={filters[key]}
            onChange={(e) => handleFilterChange(key, e.target.value)}
            className={`appearance-none border-none rounded-md px-4 py-2 pr-8 text-sm cursor-pointer outline-none min-w-30 transition-colors duration-300 ${
              isDarkMode 
                ? 'bg-gray-700 text-gray-300' 
                : 'bg-gray-50 text-gray-600'
            }`}
          >
            <option value="">{key.charAt(0).toUpperCase() + key.slice(1)}</option>
            {options.map(option => (
              <option key={option} value={option.toLowerCase().replace(' ', '-')}>
                {option}
              </option>
            ))}
          </select>
          <div className={`absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-xs ${
            isDarkMode ? 'text-gray-400' : 'text-gray-500'
          }`}>
            ▼
          </div>
        </div>
      ))}
    </div>
  );
};

export default FilterBar;